import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, useGrid, usePopup, useStore, useToast, useModal, useAuth } from "@/comn/hooks";
import { BASE, APIS, SF_CO_BUCN_SRCH, SG_CO_BUCN_LIST } from "./services/ComnCdService";
import { Link } from "react-router-dom";

export const CoBucnList = (props: any) => {
    const pgeUid = "coBucnLst";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const params = props.params;
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    const form = {
        coBucnSrch: useForm({
            defaultSchema: SF_CO_BUCN_SRCH,
            // defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    const grid = {
        coBucnLst: useGrid({
            defaultSchema: SG_CO_BUCN_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getCoBucnLst: useFetch({
            api: (page = grid.coBucnLst.page) => {
                return APIS.getCoBucnLst(
                    { ...form.coBucnSrch.getValues(), coTin: auth.get("tin") },
                    page,
                    grid.coBucnLst.size,
                );
            },
            enabled: comnUtils.isEmpty(form.coBucnSrch.errors) && form.coBucnSrch.isSubmitted,
            key: [grid.coBucnLst.page, grid.coBucnLst.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.coBucnSrch.getValues(),
                    page: grid.coBucnLst.page,
                    size: grid.coBucnLst.size,
                });
            },
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.coBucnSrch.handleSubmit(
                () => {
                    grid.coBucnLst.setPage(0);
                    fetch.getCoBucnLst.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },

        /* * */
        click_Btn_Apply: () => {
            const list: any[] = grid.coBucnLst.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.osc.00084" });
                return;
            }

            props?.callback?.({ data: list });
            modal.closeModal(props.id);
        },
    };

    const render = {
        grid_CoBucnLst: {
            cell: {
                bucnTin: (arg: any) => {
                    const { binding, rowValues, value } = arg;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                props?.callback?.({ code: value, label: rowValues.bucnNm, data: rowValues });
                                modal.closeModal(props.id);
                            }}
                        >
                            {arg.value}
                        </Link>
                    );
                },
            },
        },
    };

    useEffect(() => {
        handler.click_Btn_Srch();
        /* * */
        if (params?.multiple === true) {
            grid.coBucnLst.setOption("checkbox", true);
        }
    }, []);

    return (
        <Page title={t("T_CO_BUCN_LST")} info={true}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.coBucnSrch.schema.bucnTin}></Group.Control>
                                <Group.Control {...form.coBucnSrch.schema.bucnNm}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.coBucnSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.click_Btn_Srch();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    {/* * */}
                    {params?.multiple === true && (
                        <Layout>
                            <Layout.Right>
                                <Button
                                    role="apply"
                                    onClick={() => {
                                        handler.click_Btn_Apply();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    )}
                    <Grid
                        {...grid.coBucnLst.grid}
                        data={fetch.getCoBucnLst.data?.coBucnList}
                        render={render.grid_CoBucnLst}
                    />
                </Group.Body>
            </Group>
        </Page>
    );
};
